import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import profile from '../../assets/svgs/dummy_image.svg';
import { profileStyles as styles } from './profile.tailwind';
import ProfilePopover from '../shared/Popover/ProfilePopover/ProfilePopover'; // Adjust the import path as necessary
import { filterString } from '../../lib/constants/globalConstant';

const Profile = ({ showSeasonDropdown, setSeasonUpdating }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [errorLoadingProfileImage, setErrorLoadingProfileImage] = useState(false);


    const { user } = useSelector(state => state.user)

    // Handle click event on profile image to toggle popover
    const handleProfileClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget); // Toggle the popover visibility
    };

    const handleClose = () => {
        setAnchorEl(null); // to close the popover
    };

    return (
        <div className={styles.container}>
            {/* Section for the username */}
            {user?.userDetails?.userNickName && <div className={styles.username}>
                {filterString(user?.userDetails?.userNickName)}
            </div>}

            {/* Section for the profile image */}
            <div className={styles.profileImage} onClick={handleProfileClick}>
                {user?.userDetails?.profileImageUrl && !errorLoadingProfileImage ? (
                  <img
                    src={user.userDetails?.profileImageUrl}
                    alt="Profile"
                    className={styles.profileIcon}
                    onError={() => setErrorLoadingProfileImage(true)}
                  />
                ) : (
                  <img
                    src={profile} // fallback image
                    alt="Default Profile"
                    className={styles.profileIcon}
                  />
                )}
            </div>

            {/* Profile Popover for Logout */}
            <ProfilePopover anchorEl={anchorEl} onClose={handleClose} showSeasonDropdown={showSeasonDropdown} setSeasonUpdating={setSeasonUpdating} />
        </div>
    );
};

export default Profile;
